module.exports = "<svg viewBox=\"0 0 15 15\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"7.5\" cy=\"7.5\" r=\"7\"></circle><path d=\"M7.5 2.9l4 6.1h-8l4-6.1z\" fill=\"#FFF\"></path><path fill=\"#FFF\" d=\"M6 8h3v4H6z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/@cian/ui/app/components/icon/icons/top3.svg
// module id = 890
// module chunks = 0